export default "__VITE_ASSET__Bt39gH3q__"